import { PaywallPlans, RevalidateUserData, SignInType, SiteLinks } from '../../../../global/paywall/paywallInterfaces';
import { DetailUpdateError } from '../../../../global/paywall/useDetailsUpdate';

export const OTP_LENGTH = 6;

interface PaywallRevalidatePasswordProps {
  userData: RevalidateUserData;
  revalidationType: SignInType;
  handleContinue: () => void;
  error: DetailUpdateError;
  otp: string[];
  setOtp: (otp: string[]) => void;
  inputRefs: React.RefObject<HTMLInputElement[]>;

}declare const window: Window & {
  PAYWALL_PLANS: PaywallPlans
  PAYWALL_SITE_LINKS: SiteLinks;
}

export const PaywallRevalidatePassword = ({
  userData,
  revalidationType,
  error,
  otp,
  setOtp,
  handleContinue,
  inputRefs
}: PaywallRevalidatePasswordProps) => {
  const isOtpComplete = otp.every(value => value.trim() !== '');
  const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';
  const serverErrorMessages: Partial<Record<DetailUpdateError, string>> = {
    [DetailUpdateError.AUTHENTICATION_FAILED]: 'האימות נכשל או שפג תוקפו של קוד האימות, יש לנסות שוב',
    [DetailUpdateError.OTP_MAX_ATTEMPTS]: `חרגת ממספר בקשות אימות. יש לפנות ל<a target="_blank" href=${contactUrl}>שירות הלקוחות</a>`,
  }

  const handleChange = (value: string, index: number) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    inputRefs.current[index].style.borderColor = '#999999';
    if (value && index < OTP_LENGTH - 1) {
      const nextInput = inputRefs.current[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  const handleKeyDown = (event: KeyboardEvent, index: number) => {


    if (event.key === 'Backspace' || event.key === 'Delete' && index > 0) {
      event.preventDefault();
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);
      const prevInput = inputRefs.current[index - 1];
      if (prevInput) {
        prevInput.focus();
      }
    }
    if (event.key === 'ArrowLeft' && index > 0) {
      const prevInput = inputRefs.current[index - 1];
      if (prevInput) {
        prevInput.focus();
      }
    }
    if (event.key === 'ArrowRight' && index < OTP_LENGTH - 1) {
      const nextInput = inputRefs.current[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      if (isOtpComplete) {
        handleOnContinue();
      }
    }
  };

  const handlePaste = (event: ClipboardEvent) => {
    event.preventDefault();
    const pastedData = event.clipboardData.getData('text');
    if (pastedData.length !== otp.length || !/^\d+$/.test(pastedData)) {
      return;
    }
    const newOtp = pastedData.split('');
    setOtp(newOtp);
    if (inputRefs.current[otp.length - 1]) {
      inputRefs.current[otp.length - 1].focus();
    }
  };

  const resetOtpInputs = () => {
    setOtp(Array(OTP_LENGTH).fill(''));
    inputRefs.current.forEach((input) => {
      if (input) {
        input.style.borderColor = '#999999';
      }
    });
  }

  const handleOnContinue = () => {
    const emptyOtpFields = inputRefs.current.filter((_, index) => otp[index] === '');
    if (emptyOtpFields.length > 0) {
      emptyOtpFields.forEach((input) => {
        if (input) {
          input.style.borderColor = '#DE1A1A';
        }
      });
    } else {
      handleContinue();
    }
  }

  const getDescription = () => {
    return revalidationType === SignInType.otpEmail
      ? `שלחנו קוד אימות לכתובת דוא״ל: \n ${userData.obfuscatedEmail}`
      : `שלחנו קוד אימות למספר הטלפון הנייד: ${userData.obfuscatedPhoneNumber}****-***`;
  };

  return (
    <div className="paywall-revalidate-password">
      <div className="title">אימות מנוי</div>
      <div className="subtitle">
        <div>{getDescription()}</div>
        <div>יש להזין כאן את הקוד שקיבלת</div>
      </div>
      <div className="otp">
        {otp.map((_, index) => {
          return (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              type="text"
              inputMode="numeric"
              pattern="\d*"
              autoComplete="one-time-code"
              enterKeyHint="done"
              maxLength={1}
              value={otp[index]}
              onChange={(e: any) => handleChange(e.target.value, index)}
              onKeyDown={(e: any) => handleKeyDown(e, index)}
              onPaste={(e: any) => handlePaste(e)}
              onBeforeInput={(e: any) => handleChange(e.data, index)}
            />
          );
        })}
      </div>
      <span className="avalibale-label">הקוד תקף ל-15 דקות</span>
      {!!error && (
        <span className="error-text" dangerouslySetInnerHTML={{ __html: serverErrorMessages[error] }} />
      )}

    </div>
  );
};